import { Perfil } from "@core/models/perfil.models";


export interface Alerta {
    title: string,
    subTitle: string,
    message: string,
    products: number[],
    alertType: number,
    alertStart: string,
    alertEnd: string,
    active: boolean,
    routes: string[],
    userProfiles: number[],
    triggers: number[],
    exhibitionModes: number[]
}

export interface AlertaFiltroForm {
    title: string,
    products: number[],
    alertType: number,
    alertStart: string,
    alertEnd: string,
    active: boolean,
    routes: string[]
}


export interface AlertaForm {
    localExibicao: [LocalExibicaoAlertas];
    modoExibicao: [ModoExibicaoAlertas];
    tipoAlerta: [TipoAlertas];
    statusAlerta: [StatusAlertas];
    dataInicioExibicao: string;
    dataTerminoExibicao: string;
    perfil: [Perfil];
    gatilho: [GatilhoAlertas];
    tituloAlerta: string;
    subtituloAlerta: string;
    mensagemAlerta: string;
}

export interface LocalExibicaoAlertas {
    id: number;
    type: string;
}

export interface ModoExibicaoAlertas {
    id: number;
    type: string;
}

export interface TipoAlertas {
    id: number;
    type: string;
}

export interface StatusAlertas {
    id: number;
    type: string;
    value: boolean
}

export interface GatilhoAlertas {
    id: number;
    type: string;
    value?: string
}

export interface TipoAlerta {
    tipoAlertaId: TipoAlertaEnum;
    body: {
        titulo: string;
        subtitulo: string;
    }
}

export enum TipoAlertaEnum {
    Alerta = 1,
    Informacao = 2,
    Sucesso = 3,
    Erro = 4
}

export enum AcoesModalEnum {
    Visualizar = 'visualizar',
    Editar = 'editar',
    Criar = 'criar',
    Excluir = 'excluir',
    Ativar = 'ativar',
    Inativar = 'inativar'
}

export enum ModosExibicaoEnum {
    Modal = 1,
    Alerta = 2,
    Toast = 3,
    Popover = 4
}